import React, { Component } from 'react';
import { connect } from 'react-redux'
import { NotificationActions } from 'actionsets'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom'
import { NotificationItem } from '.'
import StyleSheet, { colorPalette } from 'styles'
import * as API from 'api'
import { withRouter } from 'react-router'
import {Loader} from 'components'
import {FormattedMessage} from 'react-intl'

export class Popover extends Component {
  constructor(props){
    super(props)
    NotificationActions.bindActions(this)
    this.state = {loaded: false, notifications: []}
  }

  componentDidMount(){
    this.loadNotifications()
  }

  loadNotifications(){
    API.Notifications.show({options: {page: { number: 1, size: 5 }}}).then(({data: notifications}) => {
      this.setState({notifications, loaded: true})
    })
  }

  handleNotificationClick = ({linkTo}) => () => {
    if(!linkTo) return
    this.props.history.push(`/${linkTo}`)
  }

  handleNotificationToggleRead = ({id, read}) => async () => {
    const action = read ? this.actions.markAsUnread([id]) : this.actions.markAsRead([id])
    await action
    this.loadNotifications()
  }

  render = () =>
    <List>
      <ListItem className={styles.listItem}>
        <Typography className={styles.listItemTitle} variant='h6'><FormattedMessage id="nav.notifications.title" /></Typography>
      </ListItem>
      {this.state.loaded ?
        this.state.notifications.map(notification =>
          <NotificationItem
            onClick={this.handleNotificationClick(notification)}
            onToggleRead={this.handleNotificationToggleRead(notification)}
            className={styles.listItem}
            notification={notification}
          />
        ) : <Loader size={100} />
      }
      <ListItem className={styles.listItem}>
        <Link className={styles.seeAllLink} to="/notifications"><FormattedMessage id="nav.notifications.view_all" /></Link>
      </ListItem>
    </List>
}

const styles = StyleSheet({
  list: {
    padding: 0
  },
  listItem: {
    background: 'white',
    marginTop: 0,
    borderBottom: '2px solid #f6f6f6',
    '& .list-item-secondary': {
      display: 'block',
      fontSize: 11,
      marginTop: 10,
      color: "#888"
    },
    '&:last-of-type': {
      borderBottom: 'none',
      paddingBottom: 8
    }
  },
  listItemTitle: {
    marginLeft: 40
  },
  seeAllLink: {
    display: 'block',
    textAlign: 'center',
    color: colorPalette.primary[0].hex(),
    fontWeight: 'bold',
    fontFamily: 'Montserrat,sans-serif',
    width: '100%'
  }
})

export default connect(({notifications}) => notifications)(withRouter(Popover))